module.exports = __webpack_public_path__ + "img/img_size1_hc.30c843fa.png";